// Small wrapper around `fetch` that aborts after `timeoutMs` so external
// services (Nominatim, Catastro, OpenDataSoft, etc.) can't stall the UI
// when they hang.
export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit = {},
  timeoutMs = 15_000
): Promise<Response> {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs)
  try {
    return await fetch(input, { ...init, signal: init.signal ?? controller.signal })
  } finally {
    clearTimeout(timeoutId)
  }
}
